import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api-client';

export function useMeQuery(enabled = true) {
  return useQuery({
    queryKey: ['users', 'me'],
    enabled,
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/users/me');
      if (error || !data) throw error ?? new Error('Failed to fetch /users/me');
      return data;
    },
  });
}
